<template>
	<div>
		
		<!-- 面包屑导航 -->
		<div class="breadcrumb f-bct  animate__animated  ">
			<div class="breadcrumb-inner" @click="$router.back()">
				<span class="crumb-label">当前位置：</span>
				<span class="crumb-home">地址管理</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-home">新增收件人</span>
				<el-image class="crumb-sep" :src="require('@/static/CodeBuddyAssets/31159_1817/14.svg')"></el-image>
				<span class="crumb-current">选择提货点</span>
			</div>
			<!-- 返回按钮 -->
			<div class="back-btn" @click="$router.back()">
				<span>{{ $t('header.breadcrumb.backBtn') }}</span>
				<el-image class="back-icon" :src="require('@/static/CodeBuddyAssets/31159_2065/7.svg')"></el-image>
			</div>
		</div>
		
		<div class="pageFrom  animate__animated  ">
			<div class="sec-title">
				<el-image :src="require('@/static/CodeBuddyAssets/31270_3509/24.svg')"></el-image>
				<span>选择自提点</span>
			</div>
			<div class="shaixuanFrom f-ct">
				<div class="iptBox country-field">
					<div class="country-trigger" @click="toggleCountryPanel">
						<span v-if="selectedCountryName" class="country-trigger-value">{{selectedCountryName}}</span>
						<span v-else class="country-trigger-placeholder">请选择</span>
						<i class="el-icon-arrow-down country-trigger-arrow" :class="{ 'arrow-up': showCountryPanel }"></i>
					</div>
					<!-- 国家弹出选择面板：搜索框 + 字母索引 -->
					<div class="country-panel" v-show="showCountryPanel" @click.stop>
						<div class="country-search">
							<el-input v-model="searchKeyword" placeholder="搜索国家/地区" class="country-search-input" clearable>
								<i slot="prefix" class="el-icon-search"></i>
							</el-input>
						</div>
						<div class="country-body">
							<div class="country-list" ref="countryList" @scroll="onCountryListScroll">
								<!-- "全部"选项固定在顶部，不参与字母分组 -->
								<div v-if="allOption" class="country-item" :class="{ active: formData.country === allOption.value }" @click="selectCountry(allOption)">
									<span class="country-name">{{allOption.label}}</span>
								</div>
								<template v-for="group in filteredCountries">
									<div class="country-group" :key="group.letter" :data-letter="group.letter">
										<div class="country-group-title">{{group.letter}}</div>
										<div class="country-item" :class="{ active: formData.country === item.value }" v-for="item in group.items" :key="item.value" @click="selectCountry(item)">
											<span class="country-name">{{item.label}}</span>
										</div>
									</div>
								</template>
								<div v-if="!allOption && filteredCountries.length === 0" class="country-empty">无匹配结果</div>
							</div>
							<div class="country-index">
								<span v-for="letter in availableLetters" :key="letter" class="country-index-item" :class="{ active: activeLetter === letter }" @click="scrollToLetter(letter)">{{letter}}</span>
							</div>
						</div>
					</div>
				</div>
				<div class="action-bar1">
					<el-button type="primary" class="submit-btn" @click="loadSiteList">筛选</el-button>
				</div>
			</div>
			<div class="zwBox" v-if="!siteList.length">
				<el-image :src="require('@/static/zw.svg')"></el-image>
				<p>暂无相关数据...</p>
			</div>
			<div class="cangList f-bct">
				<div class="info-card" @click="selectSite(index)" :class="selIdx==index?'info-card-a':''" v-for="(item,index) in siteList">
					<el-image class="card-icon" v-if="selIdx==index" :src="require('@/static/add2/40.png')"></el-image>
					<el-image class="card-icon" v-else :src="require('@/static/add2/39.png')"></el-image>
					<div class="card-body">
						<div class="card-name f-bct">
							<div class="name f-ct">
								<span class="t1">{{item.name||'--'}}</span>
							</div>
						</div>
						<div class="card-contact">
							<span>{{item.consignee||'--'}}</span>
							<span>{{item.mobile||'--'}}</span>
						</div>
						<div class="card-addr"><span class="addr-blue">{{item.countryName||'--'}}</span>{{item.provinceName}}{{item.cityName}}{{item.address}}</div>
					</div>
				</div>
			</div>
		</div>
		
		<!-- 底部按钮区 -->
		<div class="dialog-footer  animate__animated  ">
			<button class="btn-confirm" @click="submitOrder">确定</button>
		</div>
		
	</div>
</template>
<script>
import { countrylist, selfPickUpSiteList } from "/src/api/api.js"
import {mapState,mapGetters,mapActions,mapMutations} from 'vuex'
// 国家/地区中文名首字 -> 拼音首字母 映射表（用于字母索引分组，兼容中文国家名）
const CN_FIRST_LETTER = {
	'阿': 'A', '埃': 'A', '爱': 'A', '安': 'A', '澳': 'A', '奥': 'A',
	'巴': 'B', '白': 'B', '保': 'B', '北': 'B', '贝': 'B', '比': 'B',
	'冰': 'B', '波': 'B', '博': 'B', '玻': 'B', '伯': 'B', '不': 'B',
	'布': 'B',
	'赤': 'C',
	'丹': 'D', '德': 'D', '东': 'D', '多': 'D',
	'俄': 'E', '厄': 'E',
	'法': 'F', '菲': 'F', '斐': 'F', '芬': 'F', '佛': 'F',
	'冈': 'G', '刚': 'G', '哥': 'G', '格': 'G', '古': 'G', '圭': 'G',
	'哈': 'H', '海': 'H', '韩': 'H', '荷': 'H', '黑': 'H', '洪': 'H',
	'几': 'J', '加': 'J', '柬': 'J', '捷': 'J', '津': 'J',
	'喀': 'K', '卡': 'K', '科': 'K', '克': 'K', '肯': 'K', '库': 'K',
	'拉': 'L', '莱': 'L', '老': 'L', '黎': 'L', '立': 'L', '利': 'L',
	'列': 'L', '卢': 'L', '罗': 'L',
	'马': 'M', '毛': 'M', '美': 'M', '蒙': 'M', '孟': 'M', '密': 'M',
	'缅': 'M', '摩': 'M', '莫': 'M', '墨': 'M',
	'纳': 'N', '南': 'N', '尼': 'N', '挪': 'N',
	'帕': 'P', '葡': 'P',
	'日': 'R', '瑞': 'R',
	'萨': 'S', '塞': 'S', '沙': 'S', '圣': 'S', '斯': 'S', '苏': 'S',
	'索': 'S',
	'塔': 'T', '坦': 'T', '汤': 'T', '特': 'T', '突': 'T', '土': 'T',
	'瓦': 'W', '危': 'W', '委': 'W', '文': 'W', '乌': 'W',
	'西': 'X', '希': 'X', '新': 'X', '匈': 'X', '叙': 'X',
	'牙': 'Y', '亚': 'Y', '也': 'Y', '伊': 'Y', '以': 'Y', '意': 'Y',
	'印': 'Y', '英': 'Y', '约': 'Y', '越': 'Y',
	'赞': 'Z', '智': 'Z', '中': 'Z'
}
export default {
	data(){
		return {
			siteList:[],
			selIdx:0,
			formData: {
				country: '',
			},
			countryOptions: [],
			countryLoading: false,
			siteLoading: false,
			// 国家选择面板
			searchKeyword: '',
			showCountryPanel: false,
			activeLetter: '',
		}
	},
	computed: {
		// 当前选中国家名称
		selectedCountryName() {
			const item = this.countryOptions.find(o => o.value === this.formData.country)
			return item ? item.label : ''
		},
		// 顶部固定项（"全部"等空值选项，不参与字母分组）
		allOption() {
			const kw = this.searchKeyword.trim().toLowerCase()
			const opt = this.countryOptions.find(o => o.value === '')
			if (!opt) return null
			if (kw && String(opt.label).toLowerCase().indexOf(kw) === -1) return null
			return opt
		},
		// 按首字母分组 + 搜索过滤后的列表（排除"全部"）
		filteredCountries() {
			const kw = this.searchKeyword.trim().toLowerCase()
			let list = this.countryOptions.filter(o => o.value !== '')
			if (kw) {
				list = list.filter(item => String(item.label || '').toLowerCase().indexOf(kw) > -1)
			}
			return this.groupByLetter(list)
		},
		// 字母索引条：基于全部国家（排除"全部"，不随搜索变化）
		availableLetters() {
			const set = []
			this.countryOptions.forEach(item => {
				if (item.value === '') return
				const l = this.getFirstLetter(item.label)
				if (set.indexOf(l) === -1) set.push(l)
			})
			return set.sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
		}
	},
	mounted() {
		this.loadCountryList()
		this.loadSiteList()
		document.addEventListener('click', this.handleDocumentClick)
	},
	beforeDestroy() {
		document.removeEventListener('click', this.handleDocumentClick)
	},
	methods:{
		// ===== 国家选择面板相关 =====
		// 切换面板显示状态
		toggleCountryPanel() {
			this.showCountryPanel = !this.showCountryPanel
			if (this.showCountryPanel) {
				this.searchKeyword = ''
				this.activeLetter = ''
			}
		},
		// 选中国家（复刻原 el-select @change 行为：值变化时触发筛选）
		selectCountry(item) {
			const changed = this.formData.country !== item.value
			this.formData.country = item.value
			this.showCountryPanel = false
			this.searchKeyword = ''
			if (changed) this.onCountryChange()
		},
		// 点击字母索引，锚定滚动到对应分组
		scrollToLetter(letter) {
			this.activeLetter = letter
			const listEl = this.$refs.countryList
			if (!listEl) return
			const target = listEl.querySelector(`[data-letter="${letter}"]`)
			if (target) {
				listEl.scrollTo({ top: target.offsetTop, behavior: 'smooth' })
			}
		},
		// 列表滚动时高亮当前所在字母
		onCountryListScroll() {
			const listEl = this.$refs.countryList
			if (!listEl) return
			const scrollTop = listEl.scrollTop
			let current = ''
			listEl.querySelectorAll('[data-letter]').forEach(el => {
				if (el.offsetTop <= scrollTop + 1) {
					current = el.getAttribute('data-letter')
				}
			})
			this.activeLetter = current
		},
		// 提取首字母（兼容英文/中文，无法识别归入 #）
		getFirstLetter(name) {
			if (!name) return '#'
			const first = String(name).trim().charAt(0)
			if (/[a-zA-Z]/.test(first)) return first.toUpperCase()
			if (/[\u4e00-\u9fa5]/.test(first)) {
				return CN_FIRST_LETTER[first] || '#'
			}
			return '#'
		},
		// 按首字母分组
		groupByLetter(list) {
			const groups = {}
			list.forEach(item => {
				const letter = this.getFirstLetter(item.label)
				if (!groups[letter]) groups[letter] = []
				groups[letter].push(item)
			})
			const letters = Object.keys(groups).sort((a, b) => a === '#' ? 1 : b === '#' ? -1 : a.localeCompare(b))
			return letters.map(l => ({ letter: l, items: groups[l] }))
		},
		// 点击面板外部关闭
		handleDocumentClick(e) {
			if (!this.showCountryPanel) return
			const field = this.$el.querySelector('.country-field')
			if (field && !field.contains(e.target)) {
				this.showCountryPanel = false
			}
		},
		submitOrder(){
			if (this.siteList.length && this.selIdx >= 0) {
				var item = this.siteList[this.selIdx]
				localStorage.setItem('point', JSON.stringify(item));
				// console.log(item)
				// this.$bus.$emit('cangMsgGet', item)
			}
			this.back()
		},
		selectSite(index) {
			this.selIdx = index
		},
		// 国家列表
		async loadCountryList() {
			this.countryLoading = true
			const res = await countrylist({})
			this.countryLoading = false
			if(res.code==200){
				var options = [
					{ label: '全部', value: '' },
				]
				res.rows.forEach((item)=>{
					options.push({
						...item,
						label: item.name,
						value: item.id,
					})
				})
				this.countryOptions = options
			}else{this.Tips(res.msg,'error')}
		},
		// 国家切换时自动加载自提点
		onCountryChange(val) {
			this.selIdx = 0
			this.loadSiteList()
		},
		// 自提点列表
		async loadSiteList(){
			this.siteLoading = true
			var data = {}
			if(this.formData.country){
				data.countryId = this.formData.country
			}
			const res = await selfPickUpSiteList(data)
			this.siteLoading = false
			if(res.code==200){
				this.siteList = res.rows || []
			}else{this.Tips(res.msg,'error')}
		},
	},
}
</script>
<style lang="scss">
body{
	// background: #f6f7fb;
}
</style>
<style lang="scss" scoped>
/* ========== 设计令牌 ========== */
$primary: #0096FF;
$danger: #FC2933;
$text-dark: #333333;
$text-gray: #999999;
$text-muted: #C6C6C6;
$border-color: #D9D9D9;
$page-bg: #F8F8F8;
$card-bg: #FFFFFF;
$cargo-bg: #FAFCFE;
$info-bg: #FAFAFA;
$thumb-bg: #E7F6FF;
$radius-sm: 0.04rem;
$radius-md: 0.08rem;
$radius-lg: 0.12rem;

$font-lg: 0.20rem;
$font-md: 0.16rem;
$font-sm: 0.14rem;
$font-xs: 0.13rem;

$input-height: 0.50rem;
$gap-section: 0.32rem;
$gap-form: 24px;
$gap-upload: 0.14rem;
$sel-gap: 24px; // 选项间距	

/* ========== 通用区块标题 ========== */
.sec-title {
	display: flex;
	align-items: center;
	margin-bottom: 0.16rem;

	.el-image {
		width: 0.02rem;
		height: 0.20rem;
		margin-right: 0.08rem;
		// flex-shrink: 0;
		display: block;
	}

	span {
		font-size: $font-lg;
		font-weight: 500;
		color: $text-dark;
	}
}
.pageFrom{
	width: 100%;
	background: #fff;
	border-radius: 10px;
	padding: 24px 32px;
	margin-top: 24px;
	padding-bottom: 40px;
	
}
/* ========== 操作按钮区 ========== */
.action-bar {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	gap: 0.30rem;
	padding-top: 0.24rem;
	.submit-btn {
		width: 1.84rem;
		height: 0.60rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}
.action-bar1 {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	margin-left: 12px;
	.submit-btn {
		width: 1.16rem;
		height: 0.46rem;
		border-radius: 0.10rem;
		font-size: 0.18rem;
		font-weight: 500;
		transition: opacity 0.25s ease, transform 0.15s ease;
	
		&:hover {
			opacity: 0.90;
			transform: translateY(-0.01rem);
		}
	
		&:active {
			transform: translateY(0);
			opacity: 1;
		}
	}
}

/* ========== 信息卡片 ========== */
.cangList{
	
}

.info-card {
	width: 758px;
	background: #f9f9f9;
	cursor: pointer;
	border-radius: 12px;
	padding: 24px 32px;
	box-sizing: border-box;
	display: flex;
	align-items: flex-start;
	margin-top: 0.16rem;
	transition:  0.25s ;

	.card-icon {
		width: 0.20rem;
		height: 0.20rem;
		flex-shrink: 0;
		margin-right: 0.12rem;
		margin-top: 0.02rem;
	}

	.card-body {
		flex: 1;
		min-width: 0;
	}

	.card-name {
		font-size: $font-md;
		font-weight: 500;
		color: $text-dark;
		margin-bottom: 0.12rem;
		display: flex;
		align-items: center;
		.name{
			.t1{
				color: #333333;
				font-weight: bold;
			}
			.t2{
				background: #FFEDED;
				height: 22px;
				display: flex;
				align-items: center;
				padding: 0 12px;
				color: #FF4747;
				font-size: 14px;
				border-radius: 4px;
				margin-left: 8px;
			}
			.t3{
				background: #EDF6FF;
				height: 22px;
				display: flex;
				align-items: center;
				padding: 0 12px;
				color: #0096FF;
				font-size: 14px;
				border-radius: 4px;
				margin-left: 8px;
			}
		}
		.copy{
			span{
				font-size: 14px;
				color: #0096FF;
			}
			::v-deep .el-image{
				width: 15px;
				margin-right: 6px;
			}
		}
		.del{
			margin-left: 16px;
			span{
				font-size: 14px;
				color: #FC3C3C;
			}
			::v-deep .el-image{
				width: 15px;
				margin-right: 6px;
			}
		}
		.card-phone {
			margin-left: 0.20rem;
			font-weight: 400;
		}
	}

	.card-contact {
		font-size: $font-sm;
		color: $text-dark;
		margin-bottom: 0.08rem;

		span + span {
			margin-left: 0.16rem;
		}
	}

	.card-sub {
		font-size: $font-sm;
		color: $text-dark;
		margin-bottom: 0.06rem;
	}

	.card-addr {
		font-size: $font-sm;
		color: $text-gray;
		word-break: break-all;

		.addr-blue {
			color: $primary;
			margin-right: 0.06rem;
		}

		.addr-gray {
			color: $text-gray;
		}
	}
}
.info-card-a{
	transition:  0.25s ;
	span,div{
		color: #fff!important;
	}
	background: #0096FF;
}
.shaixuanFrom{
	margin-bottom: 12px;
	.iptBox{
		width: 353px;
		height: 50px;
		border-radius: 8px;
		background: #F9F9F9;
		padding: 0 20px;
		display: flex;
		align-items: center;
		::v-deep .el-input {
			width: 100%;
			height: 100%;
		}
		::v-deep .el-select {
			width: 100%;
		}
		::v-deep .el-input__inner {
			// width: 100%;
			// height: 100%;
			border: none;
			background: transparent;
			// padding: 0;
		}
		// 	text-align: left;
		// 	width: 100%;
		// 	height: 100%;
		// 	line-height: 0.78rem;
		// 	background: transparent;
		// 	border: none;
		// 	font-size: 16px;
		// 	padding: 0;
		// 	&::placeholder {
		// 		color: #A8A8A8;
		// 	}
		// 	&:focus {
		// 		border-color: transparent;
		// 		box-shadow: none;
		// 	}
		// }
	}
}
/* ===== 面包屑 ===== */
.breadcrumb {
	padding: 0 12px;
	padding-top: 24px;
	background: transparent;
}
.breadcrumb-inner {
	display: flex;
	align-items: center;
}
.crumb-label {
	font-size: 0.16rem;
	font-weight: 400;
	color: #333333;
}
.crumb-home {
	font-size: 0.16rem;
	font-weight: 400;
	color: #666666;
	cursor: pointer;
	transition: color 0.3s;
	&:hover { color: #0096FF; }
}
.crumb-sep {
	width: 0.12rem;
	height: 0.12rem;
	margin: 0 0.06rem;
}
.crumb-current {
	font-size: 0.16rem;
	font-weight: 400;
	color: #0096FF;
}
/* ===== 返回按钮 ===== */
.back-btn {
	display: flex;
	align-items: center;
	cursor: pointer;
	transition: opacity 0.3s;
	&:hover { opacity: 0.75; }
	span {
		font-size: 0.16rem;
		font-weight: 400;
		color: #0096FF;
	}
	.back-icon {
		width: 0.18rem;
		height: 0.18rem;
		margin-left: 0.06rem;
	}
}

/* ---- 弹窗底部按钮区 ---- */
.dialog-footer {
	display: flex;
	align-items: center;
	justify-content: flex-end;
	padding-top: 4px;
	margin-top: 32px;
}


/* 返回按钮 */
.btn-cancel {
	width: 184px;
	height: 60px;
	background: #E9F6FF;
	border: none;
	border-radius: 10px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #0096FF;
	cursor: pointer;
	outline: none;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.85;
	}

	&:active {
		opacity: 1;
	}
}


/* 确认修改按钮 */
.btn-confirm {
	width: 184px;
	height: 60px;
	background: #0096FF;
	border: none;
	border-radius: 10px;
	font-family: 'PingFang SC', sans-serif;
	font-size: 16px;
	font-weight: 400;
	color: #FFFFFF;
	cursor: pointer;
	outline: none;
	margin-left: 14px;
	transition: opacity 0.25s;

	&:hover {
		opacity: 0.88;
	}

	&:active {
		opacity: 1;
	}
}

/* ===== 国家选择面板（搜索 + 字母索引） ===== */
.country-field {
	position: relative;
}
.country-trigger {
	flex: 1;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: space-between;
	cursor: pointer;
	font-size: 0.16rem;
	color: #333;
	.country-trigger-placeholder {
		color: #A8A8A8;
	}
	.country-trigger-arrow {
		color: #999;
		font-size: 0.12rem;
		transition: transform 0.3s;
		&.arrow-up {
			transform: rotate(180deg);
		}
	}
}
.country-panel {
	position: absolute;
	top: calc(100% + 0.06rem);
	left: 0;
	width: 100%;
	min-width: 3.53rem;
	background: #fff;
	border-radius: 0.08rem;
	box-shadow: 0 0.08rem 0.32rem rgba(0, 0, 0, 0.16);
	z-index: 999;
	padding: 0.12rem;
	box-sizing: border-box;
}
.country-search {
	margin-bottom: 0.12rem;
	::v-deep .el-input__inner {
		height: 0.4rem;
		border: 0.01rem solid #E2E6E9;
		border-radius: 0.04rem;
		padding-left: 0.3rem;
		font-size: 0.14rem;
		color: #333;
	}
	::v-deep .el-input__inner:focus {
		border-color: #0096FF;
	}
	::v-deep .el-input__prefix {
		left: 0.08rem;
		line-height: 0.4rem;
		color: #92969F;
	}
}
.country-body {
	display: flex;
	align-items: flex-start;
}
.country-list {
	flex: 1;
	height: 3.2rem;
	overflow-y: auto;
	padding-right: 0.08rem;
	position: relative;
	&::-webkit-scrollbar {
		width: 4px;
	}
	&::-webkit-scrollbar-thumb {
		background: #ddd;
		border-radius: 2px;
	}
}
.country-group-title {
	font-size: 0.13rem;
	font-weight: 600;
	color: #0096FF;
	padding: 0.06rem 0.1rem;
}
.country-item {
	padding: 0.08rem 0.1rem;
	font-size: 0.14rem;
	color: #333;
	cursor: pointer;
	border-radius: 0.04rem;
	transition: background 0.2s, color 0.2s;
	&:hover {
		background: #F0F7FD;
		color: #0096FF;
	}
	&.active {
		background: #F0F7FD;
		color: #0096FF;
		font-weight: 500;
	}
}
.country-empty {
	text-align: center;
	color: #BFC6CE;
	font-size: 0.14rem;
	padding: 0.4rem 0;
}
.country-index {
	width: 0.36rem;
	flex-shrink: 0;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-height: 3.2rem;
	overflow-y: auto;
	border-left: 0.01rem solid #F0F0F0;
}
.country-index-item {
	font-size: 0.12rem;
	color: #666;
	cursor: pointer;
	line-height: 1.4;
	padding: 0.01rem 0;
	transition: color 0.2s;
	&:hover,
	&.active {
		color: #0096FF;
		font-weight: 600;
	}
}
</style>